export const NODE_ENV = "development";
// export const API_BASE_URL = "http://api.smallschoolbag.com/";
export const API_BASE_URL = "http://192.168.1.7:8000/";



// WEBPACK FOOTER //
// ./src/configPort/development.env.js